import { useEffect } from 'react';

const SERVICE_WORKER_UPDATE_INTERVAL = 60 * 60 * 1000;

export const useServiceWorker = () => {
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      let updateIntervalId;

      const registerServiceWorker = async () => {
        try {
          // Register the service worker
          const registration = await navigator.serviceWorker.register('/service-worker.js', {
            scope: '/',
            updateViaCache: 'none',
          });

          console.log('Service Worker registered successfully:', registration);

          // Check for updates periodically
          updateIntervalId = setInterval(() => {
            registration.update().catch((error) => {
              console.warn('Service Worker update check failed:', error);
            });
          }, SERVICE_WORKER_UPDATE_INTERVAL);

          // Listen for updates
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            if (!newWorker) return;

            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // New service worker is ready, notify the user
                console.log('New service worker version available');
                // You can show a notification here
              }
            });
          });
        } catch (error) {
          console.error('Service Worker registration failed:', error);
        }
      };

      // Register only when the window has fully loaded
      if (document.readyState === 'complete') {
        registerServiceWorker();
      } else {
        window.addEventListener('load', registerServiceWorker);
      }

      return () => {
        window.removeEventListener('load', registerServiceWorker);
        if (updateIntervalId) clearInterval(updateIntervalId);
      };
    }
  }, []);
};
